import { Injector } from '@angular/core';
import { SubpointEventInfo } from '../../../cross-team-shared/misc-services/events/mouse-event.service';
import { VectorLayerEditMode } from '../../../cross-team-shared/types/tool-modes';
import { Point2D } from '../../../team-apis/otterdam/answers/shape-typings';
import { getInsertIndex } from '../tools/edit/get-insert-index';
import { SingleSubpointTranslationHelper } from '../tools/edit/single-subpoint-translation-helper';
import { PolygonInferenceDragHandler } from '../tools/polygon/polygon-inference-drag-handler';
import { VectorDragHandler } from '../tools/shared/drag-handlers/vector-drag-handler';
import { ShapeHelper } from './shape-helper';

export class PolygonHelper extends ShapeHelper {
  override allowsSubpointSelection = true;
  override allowsAddingAndRemovingSubpoints = true;

  override getInsertIndex(oldPoints: Point2D[], newPoint: Point2D) {
    return getInsertIndex(oldPoints, newPoint, true);
  }

  override getMinPoints() {
    return 3;
  }

  override getNumberOfLines(points: Point2D[]) {
    return points.length;
  }

  override getSingleSubpointDragHandler(
    eventInfo: SubpointEventInfo,
    editMode: VectorLayerEditMode,
    injector: Injector,
  ) {
    if (editMode === 'clicky') {
      return new PolygonInferenceDragHandler(
        eventInfo,
        injector,
        new SingleSubpointTranslationHelper(
          eventInfo.shapeStore,
          eventInfo.subpointIndex,
          injector,
          'clicky',
        ),
      );
    }
    return new VectorDragHandler(
      eventInfo.event,
      injector,
      new SingleSubpointTranslationHelper(
        eventInfo.shapeStore,
        eventInfo.subpointIndex,
        injector,
      ),
      {
        restrictInteractions: true,
      },
    );
  }

  override isSubpointDraggingEnabled() {
    return true;
  }
}
